import { gql } from "@apollo/client";

export const GET_PERMIT_DOCUMENT_UPLOAD_URL = gql`
  mutation GetPermitDocumentUploadURL(
    $payeeAccountId: uuid!
    $documentTypeId: uuid!
    $filename: String!
    $contentType: String!
    $fileSize: Int!
  ) {
    permitDocumentUploadURL: get_permit_document_upload_url(
      payee_account_id: $payeeAccountId
      document_type_id: $documentTypeId
      filename: $filename
      content_type: $contentType
      file_size: $fileSize
    ) {
      id
      documentTypeId: document_type_id
      presignedURL: presigned_url
      expiresAt: expires_at
    }
  }
`;

export interface GetPermitDocumentUploadURLData {
  permitDocumentUploadURL: {
    id: string;
    documentTypeId: string;
    presignedURL: string;
    expiresAt: string;
  };
}

export interface GetPermitDocumentUploadURLVars {
  payeeAccountId: string;
  documentTypeId: string;
  filename: string;
  contentType: string;
  fileSize: number;
}
